import type { Appearance } from '@stripe/stripe-js';

const baseVariables: Appearance['variables'] = {
  colorBackground: '#ffffff',
  colorText: '#2E3549',
  borderRadius: '16px',
  fontFamily: 'CircularStd, sans-serif',
  spacingUnit: '4px',
  spacingGridRow: '24px',
};

const baseRules: Appearance['rules'] = {
  '.Label': {
    fontWeight: '700',
    fontSize: '14px',
    color: '#515E71',
    paddingBottom: '4px',
  },
  '.Input': {
    boxShadow: 'none',
    padding: '0.65rem 0.75rem',
    fontSize: '16px',
  },
};

export const stripeDefaultAppearance: Appearance = {
  variables: baseVariables,
  rules: baseRules,
};

export const stripeErrorAppearance: Appearance = {
  variables: baseVariables,
  rules: {
    ...baseRules,
    '.Input': {
      ...baseRules['.Input'],
      borderColor: '#ff3121',
    },
  },
};
